import { genericPostingActionCreator, getCookieValue } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'
import { getActiveAudits } from './searchAuditsAction'

export const loadNewAudit = () => (dispatch) => dispatch(genericPostingActionCreator('AUDIT_RECORDS', 'init'))

export const saveNewAudit = (audit) => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('AUDIT_RECORDS', 'posting'))
    fetch('/lgyhub/api/audits', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({ ...audit }),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'adding an audit')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        throw new Error(responseJson.errors[0].message)
      } else {
        dispatch(genericPostingActionCreator('AUDIT_RECORDS', 'posted', { success: true, audit: responseJson }))
        dispatch(getActiveAudits())
      }
    }).catch((error) => {
      dispatch(genericPostingActionCreator('AUDIT_RECORDS', 'error', { error: true, message: error.message} ))
      console.error('Unable to save new audit information: ', error)
    })
  }
}

export const editAudit = (audit, id) => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('AUDIT_RECORDS', 'posting'))
    fetch(`/lgyhub/api/audits/${id}`, {
      credentials: 'include',
      method: 'PATCH',
      body: JSON.stringify({ ...audit }),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'editing this audit')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        throw new Error(responseJson.errors[0].message)
      } else {
        dispatch(genericPostingActionCreator('AUDIT_RECORDS', 'posted', { success: true, audit: responseJson }))
        dispatch(getActiveAudits())
      }
    }).catch((error) => {
      dispatch(genericPostingActionCreator('AUDIT_RECORDS', 'error', { error: true, message: error.message} ))
      console.error('Audit edit failed: ', error)
    })
  }
}
